// extracted by mini-css-extract-plugin
module.exports = {"block":"BrainableBlock_block__9Okjp","blockTitle":"BrainableBlock_blockTitle__Kz5OY","blockTitleDense":"BrainableBlock_blockTitleDense__Q7lf5"};